
import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

const FilterButton = ({handleApply,handleClear}) => {
  return (
    <>
      <Box sx={{ '& button': { m: 1 } }}>

        <div style={{position:'fixed', bottom:'0px', background:"#FFFFFF"}}>
          <Button sx={{background:'#fff',
            '&:hover':{background:'#fff',}
          }} variant="outlined" size="small" color="primary" onClick={handleClear}>
            Clear all
          </Button>
          <Button variant="contained" size="small" onClick={handleApply}>
            Apply filter
          </Button>
        </div>
      </Box>
    </>
  )
}

export default FilterButton